// stores/uiStore.ts
import { defineStore } from 'pinia'

export const useUiStore = defineStore('uiStore', {
  state: () => ({
    isPageLoading: false
  }),
  actions: {
    startPageLoading() {
      this.isPageLoading = true
    },
    stopPageLoading() {
      this.isPageLoading = false
    }
  }
})
